import React, { useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import GenderMensIcon from '@moda/icons/gender-mens-12';
import GenderWomensIcon from '@moda/icons/gender-womens-12';
import { Link } from '../Link';
import { usePreferences } from '../../hooks/usePreferences';
import { hrefFor } from '../../routers';
import './DesktopSiteNavGender.scss';

const VERTICALS = [
  { name: 'women', href: hrefFor.HomePage({ vertical: 'women' }), Icon: GenderWomensIcon },
  { name: 'men', href: hrefFor.HomePageMen({ vertical: 'men' }), Icon: GenderMensIcon }
];

type Vertical = typeof VERTICALS[number];

export const DesktopSiteNavGender: React.FC = () => {
  const { vertical: preferredVertical } = usePreferences();

  const location = useLocation();

  const isWithinVertical = useCallback(
    (vertical: Vertical) =>
      location.pathname === vertical.href || location.pathname.includes(`/${vertical.name}`),
    [location.pathname]
  );

  const isNotWithinAnyVertical = useMemo(() => !VERTICALS.some(isWithinVertical), [
    isWithinVertical
  ]);

  return (
    <div className="DesktopSiteNavGender" data-testid="desktopSiteNavGender">
      {VERTICALS.map(vertical => {
        const { name, href, Icon } = vertical;
        return (
          <Link
            key={name}
            className={classNames('DesktopSiteNavGender__link', {
              'DesktopSiteNavGender__link--active':
                isWithinVertical(vertical) || (isNotWithinAnyVertical && preferredVertical === name)
            })}
            to={href}
          >
            <Icon />
            <span>{name}</span>
          </Link>
        );
      })}
    </div>
  );
};
